import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
    return (
        <div className="container-x py-24 text-center" data-testid="not-found-page">
            <Seo title="Page Not Found | Atlanta Enclave Shilphata" description="The page you are looking for does not exist. Explore Atlanta Enclave Shilphata – 1, 2 & 3 BHK flats in Shilphata, Thane." path="/404" />
            <p className="eyebrow">404</p>
            <h1 className="font-display mt-3 text-4xl font-medium text-[#23231f] sm:text-5xl">Page Not Found</h1>
            <p className="mx-auto mt-4 max-w-md text-sm text-[#55534a]">
                The page you are looking for may have moved. Explore Atlanta Enclave Shilphata instead:
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
                <Link to="/" className="btn btn-gold" data-testid="notfound-home-link">Home</Link>
                <Link to="/floor-plans/" className="btn btn-line" data-testid="notfound-floorplans-link">Floor Plans</Link>
                <Link to="/contact/" className="btn btn-line" data-testid="notfound-contact-link">Contact</Link>
            </div>
        </div>
    );
}
